// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'row';

export const Component = () => (
  <path d='M1.437 1.934h22.126v3.834H1.437V1.934ZM24.5 6.75V1H.5v5.75h24ZM1.437 10.583h22.126v3.833H1.437v-3.833ZM24.5 15.35V9.6H.5v5.75h24ZM1.437 19.185h22.126v3.834H1.437v-3.834ZM24.5 24v-5.75H.5V24h24Z' />
);

export const viewBox = '0 0 25 25';
